export const tAndCsScreenTitle = 'Terms & Conditions';
export const inviteProgressScreenTitle = 'My Invite Progress';
export const inviteProgressScreenIntro =
  'Earn free spins by inviting friends to sign up and deposit at MrQ';
